import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import Partners from '../components/Partners';
import TargetGroups from '../components/TargetGroups';
import Team from '../components/Team';
import './PartnershipsPage.css';

const PartnershipsPage = () => {
  const { language } = useLanguage();

  return (
    <div className="partnerships-page">
      <div className="page-hero">
        <div className="container">
          <div className="page-hero-content">
            <h1 className="page-title">
              {language === 'ar' ? 'الشراكات' : 'Partnerships'}
            </h1>
            <p className="page-subtitle">
              {language === 'ar' 
                ? 'شركاؤنا والفئات المستهدفة وفريقنا'
                : 'Our partners, target groups, and team'}
            </p>
          </div>
        </div>
      </div>
      
      <Partners />
      <TargetGroups />
      <Team />
    </div>
  );
};

export default PartnershipsPage;
